import { ACTIVATION_SELECT_ENABLE } from "./ItemMyStatBase"


export class ReqTeamList {
    constructor({ start, limit, team_name = "", league_association = "", team_activation = ACTIVATION_SELECT_ENABLE }) {
        this.start = start
        this.limit = limit
        this.team_name = team_name
        this.league_association = league_association
        this.team_activation = team_activation
    }

    fromJson(jsonData) {
        this.start = jsonData.start || 0
        this.limit = jsonData.limit || 10
        this.team_name = jsonData.team_name || ""
        this.league_association = jsonData.league_association || ""
        this.team_activation = jsonData.team_activation
    }

    get_team_activation() {
        return this.team_activation === 1 ? true : false
    }
}

export class ReqTeamDetail {
    constructor({team_id}){
        this.team_id = team_id
    }
    fromJson(jsonData){
        this.team_id = jsonData.team_id
    }
}

export class RespTeam {
    constructor({team_id, team_name, team_name_eng, team_activation, team_last_change, team_note, logo_team, logo_team_auth, logo_team_date, league_association, park_home, team_GM_name, team_manager_name, team_web}){
        this.team_id = team_id 
        this.team_name = team_name 
        this.team_name_eng = team_name_eng 
        this.team_activation = team_activation 
        this.team_last_change = team_last_change 
        this.team_note = team_note
        this.logo_team = logo_team 
        this.logo_team_auth = logo_team_auth
        this.logo_team_date = logo_team_date
        this.league_association = league_association
        this.park_home = park_home
        this.team_GM_name = team_GM_name
        this.team_manager_name = team_manager_name
        this.team_web = team_web
    }

    fromJson(jsonData){
        this.id = jsonData._id
        this.team_id = jsonData.team_id 
        this.team_name = jsonData.team_name 
        this.team_name_eng = jsonData.team_name_eng 
        this.total_players = jsonData.total_players || 0
        this.team_activation = jsonData.team_activation
        this.team_last_change = jsonData.team_last_change 
        this.league_association = jsonData.league_association
        this.league_name = jsonData.league_name
        this.park_home = jsonData.park_home
        this.park_name = jsonData.park_name
        this.team_GM_name = jsonData.team_GM_name
        this.team_manager_name = jsonData.team_manager_name
        this.team_note = jsonData.team_note
        this.logo_team = jsonData.logo_team 
        this.logo_team_auth = jsonData.logo_team_auth
        this.logo_team_date = jsonData.logo_team_date
        this.team_web = jsonData.team_web
        this.team_history_items = jsonData.team_history
    }

    delLogo(){
        this.logo_team_date = null
    }
}


export class RespTeamHistory {
    constructor({team_history_id, team_id="", team_name="", team_name_eng="", team_duration_start=null, team_duration_end=null}){
        this.team_history_id = team_history_id
        this.team_id = team_id 
        this.team_name = team_name 
        this.team_name_eng = team_name_eng 
        this.team_duration_start = team_duration_start 
        this.team_duration_end = team_duration_end 
        this.team_duration_start_err = false
        this.team_duration_end_err = false 
    }

    fromJson(jsonData){
        this.team_history_id = jsonData.team_history_id
        this.id = jsonData._id
        this.team_id = jsonData.team_id 
        this.team_name = jsonData.team_name 
        this.team_name_eng = jsonData.team_name_eng 
        this.team_duration_start = jsonData.team_duration_start
        this.team_duration_end = jsonData.team_duration_end 
        this.team_duration_start_err = false
        this.team_duration_end_err = false 
    }
}

export class ReqTeamListArray {
    constructor({ team_activation = ACTIVATION_SELECT_ENABLE, remove=[] }) {
        this.team_activation = team_activation
        this.remove = remove
    }

    fromJson(jsonData) {
        this.team_activation = jsonData.team_activation
        this.remove = jsonData.remove
    }
}

export class RespTeamArray {
    constructor({team_id, team_name}){
        this.team_id = team_id 
        this.team_name = team_name 
    }

    fromJson(jsonData){
        this.team_id = jsonData.team_id 
        this.team_name = jsonData.team_name 
    }
}
